module.exports = __webpack_public_path__ + "img/icon-shelly.be1ff992.svg";